import React from 'react'
import { AppBar, TitlePortal } from 'react-admin'
import { Box, useMediaQuery } from '@mui/material'

import { Logo } from '../theme/Logo'
import MyUserMenu from './MyUserMenu'

const MyAppBar = (props) => {
  const isLargeEnough = useMediaQuery((theme) => theme.breakpoints.up('sm'))
  return (
    <AppBar {...props} userMenu={<MyUserMenu />}>
      <TitlePortal />
      {isLargeEnough && <Logo />}
      {isLargeEnough && <Box component="span" sx={{ flex: 1 }} />}
    </AppBar>
  )
}

export default MyAppBar
